import {EditGenericEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AgendaEditGenericEventFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues: EditGenericEventFormValidationSchema
}) => {
    const form = useForm<EditGenericEventFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(EditGenericEventFormValidationSchema),
        defaultValues: defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
